<div class="coupon-grid-container">
    <div class="sort-by-tag">
        <app-sort *ngIf="_window.innerWidth > 991 && couponsSecondary?.length > 0 && couponGridEnableSort && !isBonusPath" [sortRules]='sortRules' [activeSortRule]='activeSortRule'
            (activeSortRuleEmitter)='activeSortRuleEmitter($event)'>
        </app-sort>
    </div>
    <app-filter-chips *ngIf="!isBonusPath"></app-filter-chips>
    @defer (when couponsSecondary?.length > 0) {
        <app-deals-hub [isBonusPath]="isBonusPath"></app-deals-hub>
    }
  <div id="noOffersFound" class="coupon-grid-offers"
       *ngIf="!allDealsDuplicateBannersDisabled && !isBonusPath && (couponsSecondary && couponsSecondary?.length == 0 && displayNoResults && couponGridType != 'instant-allocation' && couponGridType != 'freshpassevents')">
    <h3>No Offers found</h3>
  </div>
  <div class='coupon-grid-offers' *ngIf="!allDealsDuplicateBannersDisabled">
    <ng-container *ngFor="let iter of [1,2,3,4]; let iterIndex = index">
      <ng-container *ngFor="let coupon of getCouponList(iterIndex); let i = index;trackBy:trackByFn">
        <div class="section-heading product-group sort-by-aisle"
             *ngIf="coupon.isGroupSplit && isAisleSort && !isBonusPath">
          <h2 *ngIf="coupon.purchaseInd=='B'">Recommended for U</h2>
          <h2 *ngIf="coupon.purchaseInd=='L'">More Savings for U</h2>
        </div>
        <loyalty-card-al-v1 [cardType]="'coupon'" [couponDisplayFormat]="'grid'" [cardData]="coupon" [configObj]="configObj" (clipCouponEvent)="clipCouponErrHandler($event)"
                            [cardIndex]="i" class="col-12 col-sm-12 col-md-6 col-lg-4 coupon-grid-offer px-2"
                            [logoProps]="logoProps" (couponToFocusOn)="getFocusOn($event)" (openSpaOfferDetailsPage)="goToOfferDetailsPage(coupon)"></loyalty-card-al-v1>
      </ng-container>
      <ng-container *ngIf="iter !== 4 && !isB2B" >
        <banner-unit-v1 [bannerPositionName]="'midb'+ iter" class="col-12 col-sm-12 col-md-12 col-lg-12 coupon-grid-offer">
        </banner-unit-v1>
      </ng-container>
    </ng-container>
  </div>
    <div class='coupon-grid-offers' *ngIf="couponsSecondary?.length > 0 && allDealsDuplicateBannersDisabled">
        <ng-container *ngFor="let coupon of couponsSecondary; let i = index;trackBy:trackByFn">
                <div class="section-heading product-group sort-by-aisle"
                    *ngIf="coupon.isGroupSplit && isAisleSort && !isBonusPath">
                    <h2 *ngIf="coupon.purchaseInd=='B'">Recommended for U</h2>
                    <h2 *ngIf="coupon.purchaseInd=='L'">More Savings for U</h2>
                </div>
            <loyalty-card-al-v1 [cardType]="'coupon'" [couponDisplayFormat]="'grid'" [cardData]="coupon" [configObj]="configObj" (clipCouponEvent)="clipCouponErrHandler($event)"
                [cardIndex]="i" class="col-12 col-sm-12 col-md-6 col-lg-4 coupon-grid-offer px-2"
                [logoProps]="logoProps" (couponToFocusOn)="getFocusOn($event)" (openSpaOfferDetailsPage)="goToOfferDetailsPage(coupon)"></loyalty-card-al-v1>
                <ng-container *ngIf="shouldDisplayBannerAtIndex(i) && !isB2B" >
                    <banner-unit-v1 [indextoInjectMidBanner]="(i)" class="col-12 col-sm-12 col-md-12 col-lg-12 coupon-grid-offer">
                    </banner-unit-v1>
                </ng-container>
        </ng-container>
        <ng-container *ngTemplateOutlet="remainingBannersTemplate"></ng-container>
    </div>
    <div id="noOffersFound" class="coupon-grid-offers"
        *ngIf="allDealsDuplicateBannersDisabled && !isBonusPath && (couponsSecondary && couponsSecondary?.length == 0 && displayNoResults && couponGridType != 'instant-allocation' && couponGridType != 'freshpassevents')">
        <h3>No Offers found</h3>
        <ng-container *ngTemplateOutlet="remainingBannersTemplate"></ng-container>
    </div>
    <div id="emptyBonusPath" *ngIf="isBonusPath && (couponsSecondary && couponsSecondary?.length == 0 && displayNoResults && couponGridType != 'instant-allocation' && couponGridType != 'freshpassevents')">
        <div class="message" [innerHtml]="bonusPathEmptyMessage"></div>
    </div>
    <div class="load-more-container"
        *ngIf="(couponChecked == 'false' || !displayNoResults) && loadType == 'loadmore' && couponsSecondary?.length < coupons?.length">
        <button aria-label="Load More coupons and deals" tabindex="0" class="btn load-more" role="button" (click)="loadMoreCoupons();">Load more</button>
    </div>
    @if(!isB2B){
        <app-sponsored-carousel-wrapper
            [pageName]="'dealsSponsoredCarousel'"
            [urlPageName]="'deals-carousel'"
            [carouselData]="{ Title: 'Featured savings' }">
        </app-sponsored-carousel-wrapper>
    }
</div>
<ng-template #remainingBannersTemplate>
  <!-- Display a banner if we don't have enough coupons-->
  <ng-container *ngIf="remainingBanners.length > 0 && !isB2B" >
    <ng-container *ngFor="let banner of remainingBanners">
      <banner-unit-v1  class="col-12 col-sm-12 col-md-12 col-lg-12 coupon-grid-offer" [bannerPositionName]="banner">
      </banner-unit-v1>
    </ng-container>
  </ng-container>
</ng-template>
<div class="modal fade" id="modal-notification" role="dialog"
    aria-labelledby="modal-label-modal-notification" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered notif-modal" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onCloseEvent()">
                    <span class="svg-icon svg-close-primary"></span>
                </button>
            </div>
            <div class="modal-body notif-styles">
                <div class="notif-styles__content">
                    <foru-plus-logo *ngIf="isForuPlusModal"
                                    height="146px"
                                    [banner]="paramService.banner"
                                    ariaLabel="forU+">
                    </foru-plus-logo>
                    <img *ngIf="!isForuPlusModal"
                         class="mx-auto"
                         [attr.alt]="modalIconAlt"
                         [src]="modalIconSrc"
                         width="166" height="146"/>
                    <div class="notif-styles__content-title">
                        {{modalTitle}}
                    </div>
                    <div class="notif-styles__content-subtitle body-text">
                        {{modalText}}
                    </div>
                    <div>
                        <button class="btn btn--size__full-width pds-btn-filled--primary d-flex align-items-center justify-content-center" aria-label="button"
                            data-dismiss="modal" (click)="navigateFromModal()">{{modalButtonText}}</button>
                    </div>
                    <div class="mx-auto mt-4">
                    <label class="d-flex pds-checkbox" for="do-not-show-again">
                        <input type="checkbox" aria-checked="false" id="do-not-show-again" (change)="toggleModalPreference($event)">
                        <span class="d-flex align-items-center justify-content-center pds-checkbox-checkmark">
                            <span class="pds-svg-checkbox-checkmark"></span>
                        </span>
                        <span class="ml-2 pds-checkbox-label">{{checkBoxLabel}}</span>
                    </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<button type="button" class="hidden" data-toggle="modal" #freshPassBonusPathModalButton
    data-target="#modal-notification">
    Show Modal
</button>
